/* global $, data, query_string */
import { displayFn as guffDisplayFn } from 'bam-node-baseball-savant/utils/guff'
import Table from 'bam-node-savant-table/table'

$(document).ready(() => {
    let ticking = false
    let isFixedHeaderShowing = false
    const tableDivId = 'homeruns'

    $('form').submit(false)

    $('#ddlTeamId').change(() => {
        $('#lblTeamId').html($('#ddlTeamId option:selected').text())
    })

    $('#ddlCat').change(() => {
        $('#lblCat').html($('#ddlCat option:selected').text())
    })

    $('#ddlYear').change(() => {
        $('#lblYear').html($('#ddlYear option:selected').text())
    })

    $('#ddlPlayerType').change(() => {
        $('#lblPlayerType').html($('#ddlPlayerType option:selected').text())
    })

    $('#ddlMin').change(() => {
        $('#lblMin').html($('#ddlMin option:selected').text())
    })

    if (query_string.player_type) {
        $('#ddlPlayerType').val(query_string.player_type).attr('selected', true)
        $('#lblPlayerType').html($('#ddlPlayerType option:selected').text())
    }

    if (query_string.cat) {
        $('#ddlCat').val(query_string.cat).attr('selected', true)
        $('#lblCat').html($('#ddlCat option:selected').text())
    }

    if (query_string.min) {
        $('#ddlMin').val(query_string.min).attr('selected', true)
        $('#lblMin').html($('#ddlMin option:selected').text())
    }

    if (query_string.year) {
        $('#ddlYear').val(query_string.year).attr('selected', true)
        $('#lblYear').html($('#ddlYear option:selected').text())
    }

    if (query_string.team) {
        $('#ddlTeamId').val(query_string.team).attr('selected', true)
        $('#lblTeamId').html($('#ddlTeamId option:selected').text())
    }
    if (query_string.sortDir) {
        $('#sortDir').val(query_string.sortDir)
    }

    if (query_string.sort) {
        $('#sort').val(query_string.sort)
    }
    const displayFn = (val, a, b, isFooter) => {
        if (isFooter) {
            return val
        }

        const fileName = val === '1' ? 'circle_check' : 'circle_cross'
        return `<img src="/sections/leaderboard/images/${fileName}.png" width="24" />`
    }

    if (data && data.length > 0) {
        const headers = [
            {
                name: 'Player',
                field: 'href',
                customSortField: 'player',
                headerClass:
                    'th-component-header align-left table-static-column',
                fieldClass: 'tr-data align-left table-static-column',
                photo: '<img class="player-mug" onError="this.onerror=null;this.src=\'https://content.mlb.com/images/headshots/current/60x60/generic.png\';" src="https://content.mlb.com/images/headshots/current/60x60/{1}.png">',
                photoId: 'player_id',
            },
            {
                name: 'Team',
                field: 'team_abbrev',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
                photo: '<img class="table-team-logo" src="https://www.mlbstatic.com/team-logos/{1}.svg" />',
                photoId: 'team_id',
                photoOnly: true,
            },
            {
                name: 'Year',
                field: 'year',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                type: 'number',
            },
            {
                name: 'Type',
                field: 'cat',
                headerClass: 'th-component-header align-left',
                fieldClass: 'tr-data align-left',
                displayFn: (val) => (val === 'xhr' ? 'Standard' : 'Adjusted'),
            },
            {
                name: 'Avg HR Trot',
                field: 'avg_hr_trot',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                type: 'number',
                displayFn: guffDisplayFn,
            },
            {
                name: 'Doubters <br/> <em style="font-weight: normal">HR in 1-7 Parks</em>',
                field: 'doubters',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data border-left',
                type: 'number',
            },
            {
                name: 'Mostly Gone <br/> <em style="font-weight: normal;">HR in 8-29 Parks</em>',
                field: 'mostly_gone',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                type: 'number',
            },
            {
                name: 'No Doubters<br/> <em style="font-weight: normal;">HR in all 30 Parks</em>',
                field: 'no_doubters',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                type: 'number',
            },
            {
                name: 'No Doubter %',
                field: 'no_doubter_per',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                type: 'number',
                displayFn: (val) =>
                    ['100', 100, null, undefined].includes(val)
                        ? val
                        : Number(val).toFixed(1),
            },
            {
                name: 'Actual HR',
                field: 'hr_total',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data border-left',
                type: 'number',
            },
            {
                name: 'xHR',
                field: 'xhr',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                type: 'number',
                displayFn: (val) => (val ? Number(val).toFixed(1) : val),
            },
            {
                name: 'HR-xHR',
                field: 'xhr_diff',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                type: 'number',
                displayFn: (val) => (val ? Number(val).toFixed(1) : val),
            },
            {
                name: '',
                field: '',
                headerClass:
                    'th-component-header align-center th-vertical-bottom cursor-initial',
                fieldClass: 'tr-data',
                sortable: false,
                displayFn: () =>
                    `
            <span data-video-icon style="inline-block; padding: 2px; border-radius: 50%; border: 2px solid #c2c2c2;">
                <img src="/site-core/images/video.png" style="width: 18px; cursor: pointer;">
            </span>
            `,
            },
        ]

        const width = $(`#${tableDivId}`).outerWidth()
        let repeatHeaders = false
        if (width <= 768) {
            repeatHeaders = 15
        }

        // Fix to handle old urls that are column based
        let sortVal = $('#sort').val()
        if (!Number.isNaN(Number(sortVal))) {
            sortVal =
                headers[Number(sortVal)].customSortField ||
                headers[Number(sortVal)].field
        }

        // eslint-disable-next-line no-new
        new Table({
            id: 'homeruns',
            headers,
            data,
            defaultSort: sortVal,
            defaultSortDirection: $('#sortDir').val(),
            sortClass: 'column-sort',
            subDataId: 'player_id',
            repeatHeader: repeatHeaders,
            showRank: true,
            sortCallback(column, _, { state }) {
                const url = new URL(window.location)
                url.searchParams.set('sort', column)
                url.searchParams.set('sortDir', state)
                window.history.replaceState('', '', url.toString())
            },
        })
    } else {
        $('#NoData').html('<h1>No Data Found.</h2>')
    }

    function populateUrl() {
        const parameters = {
            player_type: document.getElementById('ddlPlayerType').value,
            team: document.getElementById('ddlTeamId').value,
            min: document.getElementById('ddlMin').value,
            cat: document.getElementById('ddlCat').value,
            year: document.getElementById('ddlYear').value,
        }

        const urlParams = new URLSearchParams(parameters)

        return `/leaderboard/home-runs?${urlParams.toString()}`
    }

    const selector = '.default-table-row[id^=homeruns-tr]'
    $('#homeruns').on('click', selector, function handleClick() {
        const playerId = this.id.split('_')[1]

        const row = data.find((d) => d.player_id === playerId)

        if ($(`#homeruns-trSub_${playerId}`).is(':visible')) {
            $(`#homeruns-trSub_${playerId}`).hide()
        } else {
            const repeatHeaders = false
            $.ajax({
                method: 'GET',
                url: '/leaderboard/home-runs',
                data: {
                    type: 'details',
                    player_id: playerId,
                    year: query_string.year,
                    player_type: query_string.player_type,
                    cat: query_string.cat,
                },
            }).done((json) => {
                for (let i = 0; i < json.length; i++) {
                    // eslint-disable-next-line no-param-reassign
                    json[
                        i
                    ].video = `<a href="/sporty-videos?playId=${json[i].play_id}" target="_blank"><img src="/site-core/images/video.png" title="Show Video" style="width: 25px; height: 13px; cursor: pointer;" /></a>`
                }
                $(`#homeruns-tdSub_${playerId}`)
                    .css('background', '#e4f2f5')
                    .html(
                        `<div id="data_${playerId}" style="padding: 1rem;"></div><br/><div id="homeRunImage_${playerId}" style="text-align: center; padding-bottom: 20px; border-bottom: 2px solid #555;">` +
                            `<img class="image-loading" src="/illustrator/trajectory?player_id=${playerId}&year=${$(
                                '#ddlYear'
                            ).val()}&player_type=${$(
                                '#ddlPlayerType'
                            ).val()}" style="width: 500px;" />` +
                            `</div>`
                    )
                $(`#homeruns-trSub_${playerId}`).show()

                // eslint-disable-next-line no-new
                new Table({
                    id: `data_${playerId}`,
                    repeatHeader: repeatHeaders,
                    sortClass: 'column-sort',
                    headers: [
                        {
                            name: 'Date',
                            field: 'game_date',
                            headerClass:
                                'th-component-header align-left  table-static-column',
                            fieldClass:
                                'tr-data align-left  table-static-column',
                        },
                        {
                            name: 'Batter',
                            field: 'batter_name',
                            headerClass: 'th-component-header align-left',
                            fieldClass: 'tr-data align-left',
                            // photo: '<img class="player-mug" onError="this.onerror=null;this.src=\'https://content.mlb.com/images/headshots/current/60x60/generic.png\';" src="https://content.mlb.com/images/headshots/current/60x60/{1}.png">',
                            // photoId: 'batter_id',
                            // Don't love this...
                            displayFn: (val, dataRow, header, isFooter) => {
                                if (isFooter) {
                                    return ''
                                }

                                const [last, first] = val.split(', ')
                                const shortName = `${first[0]}. ${last}`

                                return `
                                    <img class="player-mug" onError="this.onerror=null;this.src='https://content.mlb.com/images/headshots/current/60x60/generic.png';" src="https://content.mlb.com/images/headshots/current/60x60/${dataRow.batter_id}.png">
                                    <span>${shortName}</span>
                                `
                            },
                        },
                        {
                            name: 'Pitcher',
                            field: 'pitcher_name',
                            headerClass:
                                'th-component-header align-left border-right',
                            fieldClass: 'tr-data align-left border-right',
                            // photo: '<img class="player-mug" onError="this.onerror=null;this.src=\'https://content.mlb.com/images/headshots/current/60x60/generic.png\';" src="https://content.mlb.com/images/headshots/current/60x60/{1}.png">',
                            // photoId: 'pitcher_id',
                            // Don't love this...
                            displayFn: (val, dataRow, header, isFooter) => {
                                if (isFooter) {
                                    return ''
                                }

                                const [last, first] = val.split(', ')
                                const shortName = `${first[0]}. ${last}`

                                return `
                                    <img class="player-mug" onError="this.onerror=null;this.src='https://content.mlb.com/images/headshots/current/60x60/generic.png';" src="https://content.mlb.com/images/headshots/current/60x60/${dataRow.pitcher_id}.png">
                                    <span>${shortName}</span>
                                `
                            },
                        },
                        {
                            name: "<img src='https://www.mlbstatic.com/team-logos/110.svg' class='table-team-logo' />",
                            field: 'bal',
                            headerClass: 'th-component-header align-left',
                            fieldClass: 'tr-data align-center',
                            displayFn,
                        },
                        {
                            name: "<img src='https://www.mlbstatic.com/team-logos/111.svg' class='table-team-logo' />",
                            field: 'bos',
                            headerClass: 'th-component-header align-left',
                            fieldClass: 'tr-data align-center',
                            displayFn,
                        },
                        {
                            name: "<img src='https://www.mlbstatic.com/team-logos/147.svg' class='table-team-logo' />",
                            field: 'nyy',
                            headerClass: 'th-component-header align-left',
                            fieldClass: 'tr-data align-center',
                            displayFn,
                        },
                        {
                            name: "<img src='https://www.mlbstatic.com/team-logos/139.svg' class='table-team-logo' />",
                            field: 'tb',
                            headerClass: 'th-component-header align-left',
                            fieldClass: 'tr-data align-center',
                            displayFn,
                        },
                        {
                            name: "<img src='https://www.mlbstatic.com/team-logos/141.svg' class='table-team-logo' />",
                            field: 'tor',
                            headerClass:
                                'th-component-header align-left border-right',
                            fieldClass: 'tr-data align-center border-right',
                            displayFn,
                        },
                        {
                            name: "<img src='https://www.mlbstatic.com/team-logos/145.svg' class='table-team-logo' />",
                            field: 'cws',
                            headerClass: 'th-component-header align-left',
                            fieldClass: 'tr-data align-center',
                            displayFn,
                        },
                        {
                            name: "<img src='https://www.mlbstatic.com/team-logos/114.svg' class='table-team-logo' />",
                            field: 'cle',
                            headerClass: 'th-component-header align-left',
                            fieldClass: 'tr-data align-center',
                            displayFn,
                        },
                        {
                            name: "<img src='https://www.mlbstatic.com/team-logos/116.svg' class='table-team-logo' />",
                            field: 'det',
                            headerClass: 'th-component-header align-left',
                            fieldClass: 'tr-data align-center',
                            displayFn,
                        },
                        {
                            name: "<img src='https://www.mlbstatic.com/team-logos/118.svg' class='table-team-logo' />",
                            field: 'kc',
                            headerClass: 'th-component-header align-left',
                            fieldClass: 'tr-data align-center',
                            displayFn,
                        },
                        {
                            name: "<img src='https://www.mlbstatic.com/team-logos/142.svg' class='table-team-logo' />",
                            field: 'min',
                            headerClass:
                                'th-component-header align-left border-right',
                            fieldClass: 'tr-data align-center border-right',
                            displayFn,
                        },
                        {
                            name: "<img src='https://www.mlbstatic.com/team-logos/117.svg' class='table-team-logo' />",
                            field: 'hou',
                            headerClass: 'th-component-header align-left',
                            fieldClass: 'tr-data align-center',
                            displayFn,
                        },
                        {
                            name: "<img src='https://www.mlbstatic.com/team-logos/108.svg' class='table-team-logo' />",
                            field: 'laa',
                            headerClass: 'th-component-header align-left',
                            fieldClass: 'tr-data align-center',
                            displayFn,
                        },
                        {
                            name: "<img src='https://www.mlbstatic.com/team-logos/133.svg' class='table-team-logo' />",
                            field: 'oak',
                            headerClass: 'th-component-header align-left',
                            fieldClass: 'tr-data align-center',
                            displayFn,
                        },
                        {
                            name: "<img src='https://www.mlbstatic.com/team-logos/136.svg' class='table-team-logo' />",
                            field: 'sea',
                            headerClass: 'th-component-header align-left',
                            fieldClass: 'tr-data align-center',
                            displayFn,
                        },
                        {
                            name: "<img src='https://www.mlbstatic.com/team-logos/140.svg' class='table-team-logo' />",
                            field: 'tex',
                            headerClass:
                                'th-component-header align-left border-right',
                            fieldClass: 'tr-data align-center border-right',
                            displayFn,
                        },
                        {
                            name: "<img src='https://www.mlbstatic.com/team-logos/144.svg' class='table-team-logo' />",
                            field: 'atl',
                            headerClass: 'th-component-header align-left',
                            fieldClass: 'tr-data align-center',
                            displayFn,
                        },
                        {
                            name: "<img src='https://www.mlbstatic.com/team-logos/146.svg' class='table-team-logo' />",
                            field: 'mia',
                            headerClass: 'th-component-header align-left',
                            fieldClass: 'tr-data align-center',
                            displayFn,
                        },
                        {
                            name: "<img src='https://www.mlbstatic.com/team-logos/121.svg' class='table-team-logo' />",
                            field: 'nym',
                            headerClass: 'th-component-header align-left',
                            fieldClass: 'tr-data align-center',
                            displayFn,
                        },
                        {
                            name: "<img src='https://www.mlbstatic.com/team-logos/143.svg' class='table-team-logo' />",
                            field: 'phi',
                            headerClass: 'th-component-header align-left',
                            fieldClass: 'tr-data align-center',
                            displayFn,
                        },
                        {
                            name: "<img src='https://www.mlbstatic.com/team-logos/120.svg' class='table-team-logo' />",
                            field: 'wsh',
                            headerClass:
                                'th-component-header align-left border-right',
                            fieldClass: 'tr-data align-center border-right',
                            displayFn,
                        },
                        {
                            name: "<img src='https://www.mlbstatic.com/team-logos/112.svg' class='table-team-logo' />",
                            field: 'chc',
                            headerClass: 'th-component-header align-left',
                            fieldClass: 'tr-data align-center',
                            displayFn,
                        },
                        {
                            name: "<img src='https://www.mlbstatic.com/team-logos/113.svg' class='table-team-logo' />",
                            field: 'cin',
                            headerClass: 'th-component-header align-left',
                            fieldClass: 'tr-data align-center',
                            displayFn,
                        },
                        {
                            name: "<img src='https://www.mlbstatic.com/team-logos/158.svg' class='table-team-logo' />",
                            field: 'mil',
                            headerClass: 'th-component-header align-left',
                            fieldClass: 'tr-data align-center',
                            displayFn,
                        },
                        {
                            name: "<img src='https://www.mlbstatic.com/team-logos/134.svg' class='table-team-logo' />",
                            field: 'pit',
                            headerClass: 'th-component-header align-left',
                            fieldClass: 'tr-data align-center',
                            displayFn,
                        },
                        {
                            name: "<img src='https://www.mlbstatic.com/team-logos/138.svg' class='table-team-logo' />",
                            field: 'stl',
                            headerClass:
                                'th-component-header align-left border-right',
                            fieldClass: 'tr-data align-center border-right',
                            displayFn,
                        },
                        {
                            name: "<img src='https://www.mlbstatic.com/team-logos/109.svg' class='table-team-logo' />",
                            field: 'ari',
                            headerClass: 'th-component-header align-left',
                            fieldClass: 'tr-data align-center',
                            displayFn,
                        },
                        {
                            name: "<img src='https://www.mlbstatic.com/team-logos/115.svg' class='table-team-logo' />",
                            field: 'col',
                            headerClass: 'th-component-header align-left',
                            fieldClass: 'tr-data align-center',
                            displayFn,
                        },
                        {
                            name: "<img src='https://www.mlbstatic.com/team-logos/119.svg' class='table-team-logo' />",
                            field: 'lad',
                            headerClass: 'th-component-header align-left',
                            fieldClass: 'tr-data align-center',
                            displayFn,
                        },
                        {
                            name: "<img src='https://www.mlbstatic.com/team-logos/135.svg' class='table-team-logo' />",
                            field: 'sd',
                            headerClass: 'th-component-header align-left',
                            fieldClass: 'tr-data align-center',
                            displayFn,
                        },
                        {
                            name: "<img src='https://www.mlbstatic.com/team-logos/137.svg' class='table-team-logo' />",
                            field: 'sf',
                            headerClass: 'th-component-header align-left',
                            fieldClass: 'tr-data align-center',
                            displayFn,
                        },
                        {
                            name: 'Gone At',
                            field: 'ct',
                            headerClass:
                                'th-component-header align-left border-left',
                            fieldClass: 'tr-data align-center border-left',
                            type: 'number',
                        },
                        {
                            name: 'Result',
                            field: 'result',
                            headerClass:
                                'th-component-header align-center border-left',
                            fieldClass: 'tr-data align-center border-left',
                            displayFn: (val) =>
                                val
                                    .split('_')
                                    .map(
                                        (d) =>
                                            d.slice(0, 1).toUpperCase() +
                                            d.slice(1)
                                    )
                                    .join(' '),
                        },
                        {
                            name: '',
                            field: 'video',
                            headerClass:
                                'th-component-header align-left border-left',
                            fieldClass: 'tr-data align-left border-left',
                        },
                    ],
                    data: json,
                    footer: [row],
                    footerClass: 'home-run-footer-class',
                    defaultSort: 'game_date',
                    defaultSortDirection: 'desc',
                })
            })
        }
    })

    window.addEventListener('scroll', () => {
        if (!ticking && data.length) {
            window.requestAnimationFrame(() => {
                checkHeaderPosition(tableDivId)
                ticking = false
            })

            ticking = true
        }
    })

    function checkHeaderPosition(divId) {
        const scrollPosY = window.scrollY
        const posTop = $(`#${divId}`).offset().top
        const height = $(`#${divId} table thead`).height()
        if (!isFixedHeaderShowing && posTop < scrollPosY) {
            isFixedHeaderShowing = true
            addStaticHeader(divId)
        } else if (isFixedHeaderShowing && posTop - height > scrollPosY) {
            $(`#${divId} table thead`).removeClass('fixed-header')
            isFixedHeaderShowing = false
        }
    }

    function addStaticHeader(divId) {
        const width = $(`#${divId}`).outerWidth()
        // $(".tr-component-row th").removeClass("column-sort");

        if (width && width > 767) {
            let tableCell = 0

            // Set TH Width before applying fixed-header
            $('.default-table-row')
                .first()
                .children('td')
                .each(function handleEach() {
                    const outerWidth = $(this).outerWidth()
                    $(`.tr-component-row th:nth-child(${tableCell + 1})`).css(
                        'width',
                        outerWidth
                    )
                    tableCell += 1
                })

            $(`#${divId} table thead`).first().addClass('fixed-header')
            tableCell = 0

            // Set TD Width before applying fixed-header
            $('.tr-component-row')
                .children('th')
                .each(function handleEach() {
                    const outerWidth = $(this).outerWidth()
                    $(`.default-table-row td:nth-child(${tableCell + 1})`).css(
                        'width',
                        outerWidth
                    )
                    tableCell += 1
                })
        }
    }

    window.addEventListener('resize', () => {
        if (isFixedHeaderShowing) {
            addStaticHeader(tableDivId)
        }
    })

    $('#btnUpdate').click(() => {
        window.location.href = populateUrl()
    })

    $('#btnCSV').click(() => {
        window.location.href = `${populateUrl()}&csv=true`
    })
})
